export const formTypeOptions = [
  {
    value: 'template',
    title: 'Template',
    description: 'Use a system template',
    disabled: false,
  },
  {
    value: 'counter_party',
    title: 'Counterparty draft',
    description: 'Use a draft received from other party',
  },
  {
    value: 'request_draft',
    title: 'Request a draft',
    description: 'Request to create a draft with reference notes and docs',
  },
];

export const getSourceType = (
  type: string,
  renewType?: string
): string | undefined => {
  const mapping: Record<string, Record<string, string>> = {
    is_renewed: {
      template: 'Renewal_Same Template',
      request_draft: 'Renewal_Request Draft',
      counter_party: 'Renewal_Counterparty',
      support_template: 'Renewal_Extension Template',
    },
    is_amend: {
      request_draft: 'Amend_Request Draft',
      counter_party: 'Amend_Counterparty',
      support_template: 'Amend_Amendment Letter',
    },
    is_terminate: {
      request_draft: 'Termination_Request Draft',
      counter_party: 'Termination_Counterparty',
      support_template: 'Termination_Termination Letter',
    },
    default: {
      template: 'Template',
      request_draft: 'Request Draft',
      counter_party: 'Counterparty',
    },
  };

  return (
    (renewType ? mapping[renewType]?.[type] : undefined) ??
    mapping?.default[type]
  );
};

export const sourceTypes: any = {
  'Renewal_Same Template': 'Renewal Same Template',
  'Renewal_Request Draft': 'Renewal Request Draft',
  Renewal_Counterparty: 'Renewal Counter Party',
  'Renewal_Extension Template': 'Renewal Extension Template',
  'Amend_Request Draft': 'Amend Request Draft',
  Amend_Counterparty: 'Amend Counter Party',
  'Amend_Amendment Letter': 'Amend Amendment Letter',
  'Termination_Request Draft': 'Termination Request Draft',
  Termination_Counterparty: 'Termination Counter Party',
  'Termination_Termination Letter': 'Terminate Termination Letter',
  Template: 'Template',
  'Request Draft': 'Request Draft',
  Counterparty: 'Counter Party',
  Renewal_Contract: 'Renewal Contract',
  Termination_Contract: 'Termination Contract',
  Amendment_Contract: 'Amendment Contract',
  Master_Contract: 'Master Contract',
};

export const sourceTypeOptions = [
  'Renewal_Same Template',
  'Renewal_Request Draft',
  'Renewal_Counterparty',
  'Renewal_Extension Template',
  'Amend_Request Draft',
  'Amend_Counterparty',
  'Amend_Amendment Letter',
  'Termination_Request Draft',
  'Termination_Counterparty',
  'Termination_Termination Letter',
  'Template',
  'Request Draft',
  'Counterparty',
].map((key) => ({
  value: key,
  label: key,
}));

export const sourceTypesArray = Object.entries(sourceTypes).map(
  ([key, value]) => ({
    id: key,
    name: value,
  })
);
